import apiClient from './Request'
import { baseUrls } from './../const'

export default {
  getPatients(id) {
    return apiClient.get(baseUrls['baseUrl'] + '/Board/GetPatient?userId=' + id)
  },
  GetCharacterizationByProduct(product) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Data/GetCharacterizationByProduct?product=' +
        product
    )
  },
  GetCharacterizationDetail(id) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Data/GetCharacterizationDetail?id=' + id
    )
  },
  GetPadCharacterizationCommentById(id) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Data/GetPadCharacterizationCommentById?id=' + id
    )
  },
  LatestPodChartDataPoint(podMac) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/Data/LatestPodChartDataPoint?podMac=' + podMac
    )
  },
  SaveCharacterization(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['baseUrl'] + '/Data/SaveCharacterization',
      data: data
    })
  },
  LatestRecords() {
    return apiClient.get(baseUrls['baseUrl'] + '/Data/LatestRecords')
  },
  DownloadRawData(macFilter, startTime, endTime, utcOffset) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/Data/Download?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        utcOffset +
        '&outputUtcOffset=' +
        utcOffset
    )
  },
  GetDataTags(filterPodMac, filterTag, filterNotesPod) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/data/GetDataTags?filterPodMac=' +
        filterPodMac +
        '&filterTag=' +
        filterTag +
        '&filterNotesPod=' +
        filterNotesPod
    )
  },
  GetDataTagById(id) {
    return apiClient.get(baseUrls['baseUrl'] + '/data/GetDataTagById?id=' + id)
  },
  SaveDataTag(inputUtcOffset, data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['baseUrl'] +
        '/data/SaveDataTag?inputUtcOffset=' +
        inputUtcOffset,
      data: data
    })
  },
  GetGroupedData(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['baseUrl'] +
        '/data/GetGroupedData?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  LatestCaliPodChartDataPoint(podMac) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/LatestCaliPodChartDataPoint?podMac=' + podMac
    )
  },
  DeleteDataTagById(id) {
    return apiClient.delete(
      baseUrls['baseUrl'] + '/data/DeleteDataTagById?id=' + id
    )
  },
  ExportDataTagById(id) {
    return apiClient.get(
      baseUrls['baseUrl'] + '/data/ExportDataTagById?id=' + id
    )
  }
}
